import { TextField } from "@mui/material";
import { useEffect, useState } from "react";

import { useDebounce } from "../../../../../../../../hooks/useDebounce";
import Svg, { SvgEnum } from "../../../../../../../ui library/components/svgs/standard/svg";

const FilterSearchLocal = ({ sxInput, filters, updateFilter, debounceMs = 300 }) => {
  const initialVal = filters.get("search") || "";
  const [searchVal, setSearchVal] = useState(initialVal);
  const debouncedSearch = useDebounce(searchVal, debounceMs);

  useEffect(() => {
    updateFilter("search", debouncedSearch || null);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [debouncedSearch]);

  useEffect(() => {
    if (!initialVal) {
      setSearchVal("");
    }
  }, [initialVal]);

  return (
    <div
      className="inline-flex items-center rounded-full border border-gray-400 py-1 pl-3"
      style={sxInput}
    >
      <Svg name={SvgEnum.HisMagnifyingGlass} />
      <TextField
        className="w-full rounded-lg text-sm placeholder:text-center"
        placeholder="Search"
        size="small"
        name="search"
        value={searchVal}
        InputLabelProps={{
          shrink: true,
          style: {
            border: "none",
          },
        }}
        onChange={(event) => {
          setSearchVal(event.target.value);
        }}
        sx={{
          "& .MuiOutlinedInput-root": {
            "& fieldset": {
              border: "none",
            },
            "&:hover fieldset": {
              border: "none",
            },
            "&.Mui-focused fieldset": {
              border: "none",
            },
          },
        }}
      />
    </div>
  );
};

export default FilterSearchLocal;
